import * as React from 'react';
import * as randomColor from 'randomcolor';
import IconAvatar from '../IconAvatar/IconAvatar';

const DriverAvatar = ({ driver, size = "64" }) => (
  <IconAvatar
    size={size}
    icon="user"
    colour={randomColor({ seed: (driver.id || 0) * 3000, luminosity: 'light' })}
  />
);

export default DriverAvatar;
